<template>
    <v-list class="overflow-y-auto" max-height="600" v-scroll.self="onScroll">
        <v-list-item
            v-for="(item, idx) in notifications.data"
            :key="idx"
            :class="{
                unread: !item.interacted_at,
                'cursor-pointer': !item.interacted_at,
            }"
            @click="handleClick(item)"
        >
            <v-list-item-avatar>
                <v-img :src="item.data.image"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title
                    class="ws-wrap"
                    :class="{
                        'soli-grey': item.interacted_at,
                    }"
                    >{{ item.data.title }}</v-list-item-title
                >
                <v-list-item-subtitle class="ws-wrap">{{
                    item.data.subtitle
                }}</v-list-item-subtitle
                ><small class="accent--text">{{
                    moment(item.created_at).fromNow()
                }}</small></v-list-item-content
            >
        </v-list-item>
        <v-skeleton-loader
            v-if="loading"
            class="mx-auto my-3"
            type="list-item-avatar-three-line@3"
        ></v-skeleton-loader>
    </v-list>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
        };
    },
};
</script>
